if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.formInput = this.form?.querySelector("[name=id]");
        if (this.formInput) this.formInput.disabled = false;

        this.cart = document.querySelector("cart-drawer");
        this.cartType = this.cart?.dataset.cartType;

        this.submitButton = this.querySelector('[type="submit"]');
        this.body = document.querySelector("body");

        if (this.cart)
          this.submitButton?.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        this.handleErrorMessage = this.handleErrorMessage.bind(this);
        this.redirectAfterSubmit = this.redirectAfterSubmit.bind(this);
        this.disableLoadingInButton = this.disableLoadingInButton.bind(this);
        this.onSubmitHandler = this.onSubmitHandler.bind(this);

        this.form?.addEventListener("submit", this.onSubmitHandler);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.cart?.setActiveElement(document.activeElement);

        const loader = this.querySelector(".loading-overlay__spinner");

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        if (loader) loader.classList.remove("hidden");

        const mainVariantId = this.formInput?.value;
        const giftInput = document.querySelector('input[name="gift_package"]:checked');
        const giftVariantId = giftInput?.dataset.activeVariant;
        const selectedGiftValue = giftInput?.value;
        let itemQty = evt.target.querySelector('[name="quantity"]')?.value;
        const isProductVarTemplate = new URLSearchParams(window.location.search).get("view") === "product-var";
        
        if (!itemQty || itemQty <= 0) {
          itemQty = 1;
        }

        const items = [
          isProductVarTemplate
            ? {
                id: mainVariantId,
                quantity: itemQty
              }
            : { id: mainVariantId, quantity: itemQty }
        ];

        if ((selectedGiftValue === 'super-premium-gift-package' ||selectedGiftValue =="princess-box-gift-package" || selectedGiftValue=="rose-box-gift-package") && giftVariantId) {
          items.push({ id: giftVariantId, quantity: itemQty });
        }

        const config = fetchConfig("json");
        config.body = JSON.stringify({
          items,
          sections: this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [],
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: mainVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.error = true;

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: mainVariantId,
                cartData: response,
              });

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.redirectAfterSubmit(response, true);
                  });
                },
                { once: true }
              );
              if (this.cartType === "drawer") quickAddModal.hide(true);
            } else {
              const isClosedCart = !document.body.classList.contains("page-overlay-cart-on");
              this.redirectAfterSubmit(response, isClosedCart);
            }
          })
          .catch((e) => {
            console.error(e);
            if (e instanceof TypeError && e.message.includes("'cart-drawer'")) {
              location.reload();
            }
          })
          .finally(() => {
            if (this.cartType === "page") {
              if (this.error) this.disableLoadingInButton();
              return;
            }
            this.disableLoadingInButton();
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            if (this.error) return;

            this.quick_add_container = document.querySelector(".wt__quick-buy__container");
            this.quick_add_overlay = document.querySelector(".wt__quick-buy--page-overlay");
            this.quick_add_product = this.quick_add_container.querySelector(".wt-product");
            this.loader = this.quick_add_container.querySelector(".wt__quick-buy-loader");

            if (!this.quick_add_container.classList.contains("hidden")) {
              this.quick_add_product?.remove();
              this.quick_add_container.classList.remove("wt__quick-buy__container--open");
              this.quick_add_overlay.classList.remove("wt__quick-buy--page-overlay--open");
              document.body.classList.remove("quick-buy-page-overlay");
              this.loader.classList.remove("hidden");
            }
          });
      }

      disableLoadingInButton() {
        this.submitButton.classList.remove("loading");
        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
      }

      redirectAfterSubmit(response, isClosedCart = true) {
        const body = document.body;
        const isCartPage = body.classList.contains("template-cart");

        if (this.cartType === "drawer" && isCartPage) {
          const overlay = document.querySelector(".wt__quick-buy--page-overlay");
          overlay.classList.remove("wt__quick-buy--page-overlay--open");
          body.classList.remove("quick-buy-page-overlay");
        } else if (this.cartType === "drawer") {
          this.cart.renderContents(response, isClosedCart);
          return;
        }

        window.location = window.routes.cart_url;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}